export const profileColors = {
  profile0: '#9b49ff',
  profile1: '#FF5D5D',
  profile2: '#FEB322',
  profile3: '#66AD41',
  profile4: '#6098F3',
  profile5: '#be3a64',
  profile6: '#D767DB',
  profile7: '#FC8A53',
  profile8: '#00D154',
  profile9: '#7F9EF3',
  profile10: '#FF6B00',
  profile11: '#DDDDDD',
};
